import React, { useState } from 'react';

import { FreecodeButton } from 'components/Button/RectangleButton';
import { Modal, Header, Body, Footer, FooterButton } from './modalElements';
import { ModalContent, ModalTextArea } from './styles';

// A generic modal that can take text input and submit or cancel
export default React.memo(
  ({ title, text, onSubmit, onCancel, isOpen = true, loading = false, placeholder = '', isFreecodeModal = false }) => {
    const [textInput, setTextInput] = useState('');

    return (
      <Modal isOpen={isOpen} isFreecodeModal={isFreecodeModal}>
        {title && <Header isFreecodeModal={isFreecodeModal}>{title}</Header>}
        <Body loading={loading}>
          {text && <ModalContent>{text}</ModalContent>}
          <ModalTextArea
            autoFocus
            value={textInput}
            onChange={(event) => setTextInput(event.target.value)}
            placeholder={placeholder}
          />
        </Body>
        <Footer>
          {onCancel &&
            (isFreecodeModal ? (
              <FreecodeButton isFreecodeButton onClick={onCancel}>
                Cancel
              </FreecodeButton>
            ) : (
              <FooterButton label="Cancel" onClick={onCancel} />
            ))}
          {isFreecodeModal ? (
            <FreecodeButton isFreecodeButton disabled={loading} onClick={() => onSubmit(textInput)}>
              Submit
            </FreecodeButton>
          ) : (
            <FooterButton label="Submit" disabled={loading} onClick={() => onSubmit(textInput)} />
          )}
        </Footer>
      </Modal>
    );
  }
);
